/**
 * What the static page knows of the visitor without asking the server.
 *
 * The application sets a cookie for the whole domain (src/shared/api/sessionHint.ts):
 * `easymusic_signed_in=1` for an account, `=guest` for a guest. An account is greeted with
 * "continue" instead of "sign in"; a guest is not signed in yet, and is offered both.
 *
 * The language links remember the choice in a cookie of the whole domain, `easymusic_lang`:
 * the gateway sends `/` to that language, and the application starts in it.
 */
const SIGNED_IN = 'easymusic_signed_in=1';
const LANGUAGE_COOKIE = 'easymusic_lang';
const YEAR = 365 * 86_400;

export function greet(): void {
  const member = document.cookie.split('; ').includes(SIGNED_IN);
  for (const el of document.querySelectorAll<HTMLElement>('[data-visitor]')) el.hidden = member;
  for (const el of document.querySelectorAll<HTMLElement>('[data-member]')) el.hidden = !member;
}

/** The domain a cookie is set for: the whole installation, which a bare host name or an address cannot name. */
function cookieDomain(): string {
  const host = location.hostname;
  return host.includes('.') && !/^[\d.]+$/.test(host) && !host.includes(':') ? `; Domain=${host}` : '';
}

export function rememberLanguageChoices(): void {
  for (const link of document.querySelectorAll<HTMLAnchorElement>('.lang-switch a[hreflang]')) {
    link.addEventListener('click', () => {
      document.cookie = `${LANGUAGE_COOKIE}=${link.hreflang}; Path=/; Max-Age=${YEAR}; SameSite=Lax${cookieDomain()}`;
    });
  }
}
